import React from 'react';
import { BottomNavigation, BottomNavigationAction, Paper } from '@mui/material';
import { Home, Category, MenuBook, Person } from '@mui/icons-material';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const BottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { currentUser } = useAuth();

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    if (newValue === '/mypage' && !currentUser) {
      navigate('/login', { state: { from: location } });
      return;
    }
    navigate(newValue);
  };

  // 현재 경로에 따른 활성화된 탭 결정
  const getActiveValue = () => {
    const pathname = location.pathname;
    
    // 마이페이지 관련 모든 경로에서 마이페이지 탭 활성화
    if (pathname.startsWith('/mypage')) {
      return '/mypage';
    }
    
    // 카테고리 관련 모든 경로에서 카테고리 탭 활성화
    if (pathname.startsWith('/category')) {
      return '/category';
    }
    
    // 기본 경로들
    switch (pathname) {
      case '/':
        return '/';
      case '/guide':
        return '/guide';
      default:
        return pathname;
    }
  };

  return (
    <Paper 
      sx={{ 
        position: 'fixed', 
        bottom: 0, 
        left: 0, 
        right: 0,
        borderTop: '1px solid #e0e0e0',
        zIndex: 1000
      }} 
      elevation={3}
    >
      <BottomNavigation
        value={getActiveValue()}
        onChange={handleChange}
        showLabels
        sx={{
          height: '64px',
          '& .MuiBottomNavigationAction-root': {
            minWidth: 'auto',
            padding: '6px 0',
            color: '#666',
          },
          '& .Mui-selected': {
            color: '#1a237e',
          },
        }}
      >
        <BottomNavigationAction
          label="홈"
          value="/"
          icon={<Home />}
        />
        <BottomNavigationAction
          label="카테고리"
          value="/category"
          icon={<Category />}
        />
        <BottomNavigationAction
          label="이용가이드"
          value="/guide"
          icon={<MenuBook />}
        />
        <BottomNavigationAction
          label="마이페이지"
          value="/mypage"
          icon={<Person />}
        />
      </BottomNavigation>
    </Paper>
  );
};

export default BottomNav; 